import React from 'react';

import { Action, Actions, ActionBar } from '@gogame/components';
import { useChooseFiles } from '@gogame/hooks-ts';
import { useLinkNavigate, useScreenTitle } from '@gogame/screens';

import { useGoogleDrive } from 'api/google/useGoogleDrive';

import { useCreateMarketingPlanning } from 'scenes/MarketingPlanning/MarketingPlanningGrid/hooks';
import { marketingPlanningWizardLink } from 'scenes/MarketingPlanning/navigation';
import {
  useImportNewCSV,
  useImportNewPlanFromGooglePicker,
} from 'scenes/MarketingPlanning/MarketingPlanningGrid/data/mutations';
import {
  DUPLICATE_PLAN,
  EMPTY_PLAN,
} from 'scenes/MarketingPlanning/MarketingPlanningGrid/constants';

export default ({ loadData }) => {
  const [title] = useScreenTitle();

  const createMarketingPlanning = useCreateMarketingPlanning();
  const marketingPlanningLinkNavigate = useLinkNavigate(
    marketingPlanningWizardLink
  );

  const chooseFiles = useChooseFiles({ accept: '.csv' });
  const [importCSV] = useImportNewCSV({
    onSuccess: loadData,
    onHasErrors: loadData,
  });

  const [importNewGD] = useImportNewPlanFromGooglePicker({
    onSuccess: loadData,
    onHasErrors: loadData,
  });

  const handleSelectFile = ({ docs, token }) => {
    docs.forEach(({ id }) => {
      importNewGD({ fileId: id, accessToken: token });
    });
  };

  const handleImportCSV = async () => {
    const [file] = await chooseFiles();
    importCSV(file);
  };

  const { onImport } = useGoogleDrive({
    onSelectFiles: handleSelectFile,
  });

  const handleCreateEmptyPlan = async () => {
    const {
      meta: { year, month },
    } = await createMarketingPlanning({
      type: EMPTY_PLAN,
    });
    marketingPlanningLinkNavigate({ year, month });
  };

  const handleDuplicateLastMonth = async () => {
    const { year, month } = await createMarketingPlanning({
      type: DUPLICATE_PLAN,
    });
    marketingPlanningLinkNavigate({ year, month });
  };

  return (
    <ActionBar
      title={title}
      primaryActions={
        <Actions>
          <Action
            border={true}
            button={true}
            add={true}
            iconContent={true}
            tooltip={'Add Monthly plan'}
            variant={'outlined'}
          >
            <Action
              id={'import'}
              label={'Imported from file'}
              onClick={handleImportCSV}
            />
            <Action
              id={'importGD'}
              label={'Imported from Google Drive'}
              onClick={onImport()}
            />
            <Action label={'Empty Plan'} onClick={handleCreateEmptyPlan} />
            <Action
              label={"Duplicated last month's"}
              onClick={handleDuplicateLastMonth}
            />
          </Action>
        </Actions>
      }
    />
  );
};
